import React from 'react'

import './Timeline.css'

export function Timeline(props) {
	return (
		<div className='timeline'>{props.children}</div>
	)
}

/**
 * 
 * @param {*} props { title  , bullet }
 * @returns 
 */
function Item(props) {

	let className = ['timeline-item'];
	if(props.className) className.push(props.className)

	className = className.join(' ')

	return (
		<div className={className}>
			<div className="timeline_item-bullet">{ props.bullet ?? ''}</div>
			<div className="timeline_item-body" onClick={ () => props.onClick ? props.onClick() : {} }>
				{ props.title && <div className="timeline_item-body-title">{props.title}</div>}
				<div className="timeline_item-body-content">{props.children}</div>
			</div>
			
		</div>
	)
}

Timeline.Item = Item
